import React, { FC } from 'react'

import AccountTitle from '../components/AccountTitle'

const CreditTitle: FC<{ FormName: string }> = ({ FormName }) => (
  <AccountTitle FormName={FormName} name="CreditTitleUNI" />
)

export default CreditTitle
